import React from 'react';
import PropTypes from 'prop-types';
import { Input, Dropdown } from '../../..';

const EMAIL = "email";
const TEAM = "team";

const Inputs = ({ onAddInput, id, email, hideMinusButton , hidePlusButton, teams, onChangeEmail, onSelectTeam, onRemoveField })=> {

  const handleSelect = team => {
    onSelectTeam(team, id, TEAM);
  }

  return (
    <div className="invite-user-modal__inputs-container__inputs">
      <Input
        type="text" 
        value={email} 
        placeholder="Email" 
        onChange={e => onChangeEmail(e.target.value, id, EMAIL)}
      />
      <Dropdown 
        items={teams}
        displayedProperty="name"
        onSelect={handleSelect}
      />
      {hidePlusButton ?
        <button type="button" style={{ color: "white", fontSize: '20px', width: '15px' }} onClick={onAddInput}>+</button> :
        <div style={{ width: "15px" }}/>
      }
      {!hideMinusButton ?
        <button type="button" style={{ color: "white", fontSize: '20px', width: '15px' }} onClick={()=>onRemoveField(id)}>-</button> :
        <div style={{ width: "15px" }}/>
      }
    </div>
  );
};

Inputs.propTypes = {
  email: PropTypes.string,
  hideMinusButton: PropTypes.bool, 
  hidePlusButton: PropTypes.bool,
  id: PropTypes.string,
  onAddInput: PropTypes.func,
  onChangeEmail: PropTypes.func,
  onRemoveField: PropTypes.func,
  onSelectTeam:PropTypes.func, 
  teams: PropTypes.array
};

Inputs.defaultProps = {
  email: "",
  hideMinusButton: false, 
  hidePlusButton: false,
  id: "",
  onAddInput: ()=> {},
  onChangeEmail: ()=> {},
  onRemoveField: ()=> {},
  onSelectTeam: ()=> {},  
  teams: []
};

export default Inputs;